import { render, staticRenderFns } from "./TerminationJudge.vue?vue&type=template&id=a3276204&"
import script from "./TerminationJudge.vue?vue&type=script&lang=js&"
export * from "./TerminationJudge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports